/*
  单个课程的数据内容
*/

export default {
  state: {
    id: null,
    name: undefined,
    covers: [],
    vipsNeeded: [],
    creditsNeeded: null,
    locked: true
  },
  mutations: {
    UPDATE_COURSE (state, course) {
      ['id', 'name', 'covers', 'vipsNeeded', 'creditsNeeded', 'locked'].forEach(key => {
        state[key] = course[key]
      })
    }
  },
  actions: {
    updateCourse ({ commit }, course) {
      commit('UPDATE_COURSE', course)
    }
  }
}
